var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
		abstract: true,
		'is-child-of-panel': this.parentBlock.name == 'qzrstudio/panel',
	}},[_c('div',{class:'font-size-25 color-' + _vm.pageColor,domProps:{"innerHTML":_vm._s(_vm.block.attrs.abstract)}}),_c('div',{staticClass:"abstract-background",class:( _obj = {}, _obj['background-' + _vm.pageColor + '-light'] = true, _obj )})])}
var staticRenderFns = []

export { render, staticRenderFns }